var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { translate } from '@utils/i18n';
import { updateSettings } from '../services/CalendarSettingsService';
import { calendarSettingsKeys } from './queryKeys';
const namespace = 'features.settings.calendar_settings';
export function useUpdateCalendarSettings() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (payload) => updateSettings(payload),
        onMutate: (payload) => __awaiter(this, void 0, void 0, function* () {
            yield queryClient.cancelQueries({ queryKey: calendarSettingsKeys.settings() });
            const previousData = queryClient.getQueryData(calendarSettingsKeys.settings());
            if (previousData) {
                queryClient.setQueryData(calendarSettingsKeys.settings(), Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, previousData), (payload.calendar_optimization_enabled !== undefined && {
                    calendarOptimizationEnabled: payload.calendar_optimization_enabled
                })), (payload.calendar_month_visit_limit !== undefined && {
                    calendarMonthVisitLimit: payload.calendar_month_visit_limit
                })), (payload.calendar_week_visit_limit !== undefined && {
                    calendarWeekVisitLimit: payload.calendar_week_visit_limit
                })), (payload.calendar_day_max_events !== undefined && {
                    calendarDayMaxEvents: payload.calendar_day_max_events
                })));
            }
            return { previousData };
        }),
        onError: (error, _variables, context) => {
            if (context === null || context === void 0 ? void 0 : context.previousData) {
                queryClient.setQueryData(calendarSettingsKeys.settings(), context.previousData);
            }
            const message = (error === null || error === void 0 ? void 0 : error.message) || translate('update_error', { namespace });
            toast.error(message);
        },
        onSuccess: () => {
            toast.success(translate('update_success', { namespace }));
        },
        onSettled: () => {
            void queryClient.invalidateQueries({ queryKey: calendarSettingsKeys.settings() });
        }
    });
}
